exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#grayOutDiv {\n  background-color: #333;\n  opacity: 0.7;\n  position: fixed;\n  top: 0px;\n  left: 0px;\n  height: 100%;\n  width: 100%;\n  overflow: hidden;\n  z-index: 9999;\n}\n.flash-message {\n  z-index: 10000;\n  position: relative;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /var/www/login.theprintlife.com/src/app/app.component.css
// module id = ../../../../../src/app/app.component.css
// module chunks = main